/* eslint-disable max-classes-per-file */

export class LoadTenantUserAccess {
  static readonly type = '[Tenant User Access] Load tenantuserAccess via Service';
  constructor(public tenantId?: string) {}
}

export class ChangeCurrentSelectedTenant {
  static readonly type = '[Tenant User Access] Change selected Tenant';
  constructor(
    public selectedTenantId: string,
    public withNavigation: boolean = true
  ) {}
}

export class ChangeCurrentSelectedDepartment {
  static readonly type = '[Tenant User Access] Change selected Department';
  constructor(
    public selectedDepartmentId: string,
    public withNavigation: boolean,
    public comingFromAllDeps?: boolean
  ) {}
}

export class PatchProfilePicture {
  static readonly type = '[Tenant User Access] Update Profile Picture';
  constructor(public profilePictureLink: string) {}
}

export class PatchCrewManagementType {
  static readonly type = '[Tenant User Access] Update Crew Management Type';
  constructor(
    public tenantId: string,
    public departmentId: string,
    public crewManagementType: number
  ) {}
}

export class PatchDepartmentModules {
  static readonly type = '[Tenant User Access] Update Department Modules';
  constructor(
    public tenantId: string,
    public departmentId: string,
    public modules: number[]
  ) {}
}

export class UpdateDepartmentAvailability {
  static readonly type = '[Tenant User Access] Update Department Availability';
  constructor(
    public departmentId: string,
    public statusId: number
  ) {}
}
